export const TEXTS = {
  MODAL_TITLE: 'Переход в СберБизнес',
  MODAL_DESCRIPTION: 'Подтвердите переход в СберБизнес для завершения привязки типа оплаты',
  MODAL_BUTTON_TEXT: 'Перейти',
};
